<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="4" :xs="24" style="height:90vh;">
        <!--      <el-row style="position:fixed;width: 15.5%; z-index: 1000;transition:all 2s;" :class='{whether:isFixed}'>-->
        <el-row style="width: 100%; z-index: 1000;transition:all 2s;" :class='{ whether: isFixed }'>
          <el-col style="padding-left:30px; ">
            <div style="background-color: #F5F5F5;width: 100%;">
              <div style="margin-bottom:10px;height: 30px;line-height: 30px;">
                <div
                  style="float: left;width: 117px;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
                  会员单位</div>
                <div style="float: right;font-size: 6px"><router-link
                    :to="{ path: '/Admissionnotice', query: { act: 'second' } }">更多>></router-link></div>
              </div>
              <div class="index-roll2">
                <vue-seamless-scroll :data="memberList" :class-option="memberUp">
                  <!-- <div :data="memberList" :class-option="memberUp"> -->
                  <ul v-for="(item, index) in memberList" :key="index">
                    <router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                      <li
                        style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;justify-content:space-around;align-items: center;">
                        <img :src="item.img">
                        <span
                          style="overflow: hidden;text-overflow: ellipsis;word-break: break-all; width: 70%;">{{ item.name }}</span>
                        <!-- <span>加入时间:{{ item.entertime }}</span> -->
                      </li>
                    </router-link>
                  </ul>
                  <!-- </div> -->
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
          <el-col style="margin-top: 10px;padding-left: 30px;">
            <div style="background-color: #F5F5F5;">
              <div style="margin-bottom:10px;height: 30px;line-height: 30px;">
                <div
                  style="float: left;width: 117px;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
                  核心专家</div>
                <div style="float: right;font-size: 6px"><router-link
                    :to="{ path: '/Technocracy', query: { act: 'second' } }">更多>></router-link></div>
              </div>
              <div class="index-roll2">
                <vue-seamless-scroll :data="expertsList" :class-option="expertsUp">
                  <!-- <div :data="expertsList" :class-option="expertsUp"> -->
                  <ul v-for="(item, index) in expertsList" :key="index">
                    <router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">

                      <li
                        style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;justify-content:space-around;align-items: center;">
                        <img :src="item.img">
                        <span> {{ item.name }}</span>
                        <!-- <span>加入时间:{{ item.entertime }}</span> -->
                      </li>
                    </router-link>
                  </ul>
                  <!-- </div> -->
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="16">
        <div style="max-width: 1200px;margin:0 auto;">
        <div class="ss">
          <div class="bs-sysMsg" style="background-color: #F5F5F5">
            <div class="title">实时动态</div>
            <div class="msg__content">
              <el-carousel height="55px" direction="vertical" :autoplay="true" :interval=1500>
                <el-carousel-item v-for="item in dynamiclbList" :key="item.id">
                  <h3 class="medium">
                    <router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">{{ item.title }}</router-link>
                  </h3>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="lb">
            <div
              style="display: flex; width: 100%;height:320px; background-color: #F5F5F5">
              <div style="width:40%;padding: 10px ;">
                <el-carousel ref="carousel">
                  <el-carousel-item v-for="(item, index) in rollList" :key="index" @click.native="linkTo">
                    <img :title="item.title" :alt="item.title" style="width:100%;height: 300px;" :src="item.img" />
                  </el-carousel-item>
                </el-carousel>
              </div>
            <div style="width: 60%;">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="行业新闻" name="first">
                  <div v-for="(item, index) in newsList" v-if="index < 8" :key="index">
                    <div class="sp">
                      <div class="pi"><router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                          <span :title="item.title">
                            {{ item.title.length > 35 ? item.title.substring(0, 35) + "..." : item.title }}
                          </span>
                        </router-link>
                      </div>
                      <div class="oi">{{item.create_time}}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="实时动态" name="second">
                  <div v-for="(item, index) in dynamiclbList" v-if="index < 8" :key="index"
                   >
                    <div class="sp">
                      <div class="pi"><router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                          <span :title="item.title">
                            {{ item.title.length > 40 ? item.title.substring(0, 40) + "..." : item.title }}
                          </span>
                        </router-link>

                      </div>
                      <div class="oi">{{item.create_time}}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="法律法规" name="third">
                  <div v-for="(item, index) in lawsList" v-if="index < 8" :key="index" >
                    <div class="sp">
                      <div class="pi"><router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                          <span :title="item.title">
                            {{ item.title.length > 40 ? item.title.substring(0, 40) + "..." : item.title }}
                          </span>
                        </router-link>

                      </div>
                      <div class="oi">{{item.create_time}}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="协会通知" name="four">
                  <div v-for="(item, index) in noticeList" v-if="index < 8" :key="index"
                   >
                    <div class="sp">
                      <div class="pi"><router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                          <span :title="item.title">
                            {{ item.title.length > 40 ? item.title.substring(0, 40) + "..." : item.title }}
                          </span>
                        </router-link>

                      </div>
                      <div class="oi">{{item.create_time}}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="党建工作" name="five">
                  <div v-for="(item, index) in workList" v-if="index < 8" :key="index" >
                    <div class="sp">
                      <div class="pi"><router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                          <span :title="item.title">
                            {{ item.title.length > 40 ? item.title.substring(0, 40) + "..." : item.title }}
                          </span>
                        </router-link>

                      </div>
                      <div class="oi">{{item.create_time}}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="six" label="更多>>"></el-tab-pane>
              </el-tabs>
            </div>
          </div>
          </div>
          <div style="margin-bottom: 10px;height:100px;">
            <a href="http://dangshi.people.com.cn/" target="_blank">
              <img style="width: 33%;height:88px;" src="static/images/1.png" />
            </a>
            <a href="https://www.china-safety.org.cn/Topic/Congress" target="_blank"><img style="width: 33%;height: 88px;"
                src="static/images/3.png" /></a>
            <a href="http://xtw.china-safety.org.cn/" target="_blank"><img style="width: 33%;height: 88px;"
                src="static/images/2.jpg" /></a>
          </div>
          <div class="jj" style="height: 350px;background-color: #F5F5F5;padding-bottom: 10px; ">
            <div
              style="background-color: rgba(37,164,180);width: 117px;height: 30px;line-height: 30px;text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
              协会简介</div>
            <div style="display: flex;justify-content: space-around;">
              <div style="padding-top: 20px;height: 250px">
                <img style="width: 350px;height: 300px" :src="jjt">
              </div>
              <div class="jian" style="overflow-y: auto;">
                <span><router-link to="/Survey"><span v-html="jianjie"></span></router-link></span>
              </div>
            </div>
          </div>

          <div style="height: 300px;padding: 20px 0;display: flex;justify-content: space-around;align-items: center;">
            <div style="background-color: #F5F5F5;width:33%">
              <div style="margin-bottom: 20px;height: 30px;line-height: 30px;">
                <div
                  style="float: left;width: 117px;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
                  主要业绩</div>
              </div>
              <div class="index-roll1">
                <div style="font-size: 18px;font-weight: bold;">{{ performancetitle }}</div>
                <div class="" style="padding: 0 20px 10px 0;font-size: 13px;text-align: justify;text-indent:2em"
                  v-html="performancecontent"></div>
              </div>
            </div>
            <div style="background-color: #F5F5F5;width:32%;padding: 0 5px;">
              <div style="margin-bottom: 20px;height: 30px;line-height: 30px;">
                <div
                  style="float: left;width: 117px;background-color: rgba(37,164,180);font-weight: bold;font-size: 19px;color: #fff;">
                  服务内容</div>
                <!-- <div style="float: right;font-size: 6px"><router-link :to="{path:'/Admissionnotice',query:{act:'second'}}">更多>></router-link></div> -->
              </div>
              <div class="index-roll1">
                <div class="stand">
                  <!-- <a href="#/Laws">安全生产标准化</a> -->
                  <router-link :to="{ path: '/Laws', query: { act: 'fourth' } }">安全生产标准化</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'fifth' } }">安全管家</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'sixth' } }">隐患排查治理</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'seventh' } }">化工园区安全提升服务</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'eighth' } }">安全仪表系统完整性评估</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'nineth' } }">安全培训</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'tenth' } }">标准宣贯</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'eleventh' } }">团体标准制定</router-link>
                </div>
                <div class="stand">
                  <router-link :to="{ path: '/Laws', query: { act: 'twelfth' } }">往期回顾</router-link>
                </div>
              </div>
            </div>

            <div style="background-color: #F5F5F5;width:33%">
              <div style="margin-bottom: 20px;height: 30px;line-height: 30px;">
                <div
                  style="float: left;width: 117px;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
                  公示公告</div>
                <!--          <div style="float: right;font-size: 6px"><router-link to="/Admissionnotice">更多>></router-link></div>-->
              </div>
              <div class="index-roll1">
                <div v-for="(item, index) in opencontent" :key="index" @click="viewWebPartner(item.url)">
                  <div :class="index % 2 == 0 ? 'content1' : 'content2'" class="content">
                    <!-- <router-link :to="{name:'Newsparticulars',params:{content:item.message,userName:item.nian+'-'+item.month+'-'+item.day,pageViews:item.pageViews}}">{{ item.title }}</router-link> -->
                    <router-link :to="{ name: 'Newsparticulars', query: { id: item.id } }">
                      <span :title="item.title">
                            {{ item.title.length > 22 ? item.title.substring(0, 22) + "..." : item.title }}
                      </span>
                    </router-link>
                  </div>
                </div>

                <!-- <div style="font-size: 18px;font-weight: bold;">{{ opentitle }}</div>
          <div class="pa"  style="padding-bottom: 20px;font-size: 13px;text-align: justify;text-indent:2em" v-html="opencontent.replace(/\n/g,'<br/>')"></div> -->
              </div>
            </div>

          </div>
          <div style="clear: both;"></div>
          <div style="margin: 10px 0; width: 100%;">
            <a href="http://www.aqsc.cn/zhuanti/col1652.html" target="_blank">
              <img style="width: 33%;height: 88px;" src="static/images/4.jpg" />
            </a>
            <a href="https://www.emerinfo.cn/zt/20200615aqpjjgzyxwzxzz/index.htm" target="_blank"><img
                style="width: 33%;height: 88px;" src="static/images/6.jpg" /></a>
            <a href="https://www.ciedu.com.cn/home/org/FullSite" target="_blank"><img style="width: 33%;height: 88px;"
                src="static/images/hg.png" /></a>


          </div>
          <div style="height: 290px;background-color: #F5F5F5;margin-bottom: 20px;width:100%">
            <div style="margin-bottom: 20px;height: 30px;line-height: 30px;display:flex;justify-content: space-between">
              <div
                style="width: 117px;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
                教育平台</div>
              <div style="font-size: 6px"><router-link
                  :to="{ path: '/Publicityedu', query: { act: 'second' } }">更多>></router-link></div>
            </div>
            <div style="display:flex;justify-content: space-around;width: 100%;cursor: pointer;">
              <div v-for="(item, index) in educationList" v-if="index < 3" :key="index">
                <div style="margin-bottom: 30px;width:100%;">
                  <div style="" @click="con(item.href)">
                    <img style="width:100%; height: 210px;" :src=item.img>
                    <br>
                    <div style="display:flex;justify-content: space-around">
                      <div
                        style="width:260px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: block;font-size: 14px">
                        {{ item.title }}
                      </div>
                      <!--              <div style="font-size: 14px">
                浏览量:{{ item.views }}
              </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height:50px;background-color: #F5F5F5;margin-bottom: 20px;">

            <el-form :inline="true" style="text-align: left;padding-left: 5px;line-height: 50px;">
              <el-form-item>
                <span style="line-height: 50px;"> 友情链接 | </span>
              </el-form-item>
              <el-form-item label="政府部门网站">
                <el-select v-model="title" placeholder="选择政府部门网站" style="line-height: 50px;" @change="viewWebPartner2">
                  <el-option v-for="item in gdwebList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="相关协会网站">
                <el-select v-model="title1" placeholder="选择相关协会网站" style="line-height: 50px;" @change="viewWebPartner1">
                  <el-option v-for="item  in rawebList" :key="item.id" :label="item.title1" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      </el-col>
      <el-col :span="4" :xs="24" style="padding-right:3%;">
        <div style="background-color: #F5F5F5;">

          <div style="margin-bottom: 10px;height: 30px;line-height: 30px;">
            <div
              style="width: 117px; float: left;background-color: rgba(37,164,180);text-align: center;font-weight: bold;font-size: 19px;color: #fff;">
              合作机构</div>
            <!--          <div style="float: right;font-size: 6px"><router-link to="/Admissionnotice">更多>></router-link></div>-->
          </div>
          <div class="index-roll2">
            <vue-seamless-scroll :data="institutionsList" :class-option="institutionsUp">
              <!-- <div :data="institutionsList" :class-option="institutionsUp"> -->
              <ul>
                <li v-for="(item, index) in institutionsList" :key="index">
                  <span
                    style="padding-top: 10px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;width: 100%;">{{ item.name }}</span>
                </li>
              </ul>
              <!-- </div> -->
            </vue-seamless-scroll>
          </div>
        </div>
      </el-col>

    </el-row>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      isFixed: false,
      activeName: 'first',
      jianjie: "",
      jjt: "",
      rollList: [],
      dynamiclbList: [],
      newsList: [],
      lawsList: [],
      noticeList: [],
      workList: [],
      memberList: [],
      expertsList: [],
      institutionsList: [],
      educationList: [],
      qe: 'first',
      opentitle: '',
      opencontent: [],
      performancecontent: '',
      performancetitle: '',
      gdwebList: [
        { id: '1', title: '中华人民共和国应急管理部', url: 'https://www.mem.gov.cn/' },
        { id: '2', title: '中国安全生产科学研究院', url: 'https://www.chinasafety.ac.cn/' },
        /*{id:'3',title:'中华人民共和国安全管理部',url:'static/images/pingtai.png'},
        {id:'4',title:'中华人民共和国安全管理部',url:'static/images/pingtai.png'},*/
      ],
      rawebList: [
        { id: '1', title1: '中国安全生产协会', url: 'https://www.china-safety.org.cn/' },
        { id: '2', title1: '中国化学品安全协会', url: 'http://www.chemicalsafety.org.cn/' },
        { id: '3', title1: '化学工业出版社有限公司', url: 'http://www.cip.com.cn/' },
        { id: '4', title1: '中国石油和化学工业联合会', url: 'http://www.cpcif.org.cn/' },
      ],
      title: '',
      title1: '',
    };
  },
  created() {
    this.roll();
    this.dynamiclb();
    this.news();
    // this.laws();
    //this.notice();
    //this.work();
    this.introduction();
    this.member();
    this.experts();
    this.institutions();
    this.education();
    this.open();
    this.performance();

  },
  computed: {

  },
  mounted() {


  },
  destroyed() {

  },
  methods: {
    // handleScroll(){
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   var offsetTop = document.querySelector('#left').offsetTop
    //    scrollTop > offsetTop ? this.isFixed = true : this.isFixed = false
    //   //this.whether = scrollTop > offsetTop
    // },
    viewWebPartner2() {
      if (this.title == '1') {
        let url = 'https://www.mem.gov.cn/'
        window.open(url)
        // let href = window.location.href.split('#')[0]+'https://www.mem.gov.cn/'
        // console.log(href)
        //         window.open(href,"_self")

      } else if (this.title == '2') {
        let url = 'https://www.chinasafety.ac.cn/'
        window.open(url)
      }

    },
    viewWebPartner1() {
      console.log(this.title1)
      if (this.title1 == '1') {
        let url = 'https://www.china-safety.org.cn/'
        window.open(url)
      } else if (this.title1 == '2') {
        let url = 'http://www.chemicalsafety.org.cn/'
        window.open(url)
      } else if (this.title1 == '3') {
        let url = 'http://www.cip.com.cn/'
        window.open(url)
      } else if (this.title1 = '4') {
        let url = 'http://www.cpcif.org.cn/'
        window.open(url)
      }

    },
    /*主要业绩*/
    performance() {
      let params = {}
      this.axios.post('/api/index/performanceList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.performancetitle = response.data.data.message
          this.performancecontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*信息公开*/
    open() {
      let params = {}
      this.axios.post('/api/index/openList', params).then((response) => {
        console.log(response)
        /*if(response.data.msg == 'success'){*/
        for (var i = 0; i < response.data.data.data.length; i++) {
          var time = response.data.data.data[i].create_time
          var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
          var nian = timearr[0];
          var yue = timearr[1];
          var ri = timearr[2];
          this.opencontent.push({
            id: response.data.data.data[i].id,
            title: response.data.data.data[i].title,
            message: response.data.data.data[i].message,
            month: yue,
            day: ri,
            nian: nian,
            pageViews: response.data.msg
          })
        }
        // this.opentitle = response.data.data.data.title
        // this.opencontent = response.data.data.value
        /*}*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*轮播图*/
    roll() {
      let params = {}
      this.axios.post('/api/index/roll', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {

          this.rollList = response.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*实时动态*/
    dynamiclb() {
      let params = {}
      this.axios.post('/api/index/dynamiclbList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.dynamiclbList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*行业新闻*/
    news() {
      let params = {}
      this.axios.post('/api/index/newsList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.newsList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*法律法规*/
    laws() {
      let params = {}
      this.axios.post('/api/index/lawsList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.lawsList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*协会通知*/
    notice() {
      let params = {}
      this.axios.post('/api/index/noticeList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.noticeList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*党建工作*/
    work() {
      let params = {}
      this.axios.post('/api/index/workList', params).then((response) => {
        console.log(response)
        if (response.data.msg == 'success') {
          this.workList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*协会简介*/
    introduction() {
      let params = {}
      this.axios.post('/api/index/introductionList', params).then((response) => {
        if (response.data.msg == 'success') {
          this.jianjie = response.data.data.value
          this.jjt = response.data.data.img
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*协会会员*/
    member() {
      let params = {}
      this.axios.post('/api/index/memberList', params).then((response) => {
        if (response.data.msg == 'success') {
          var ces = []
          for (var i = 0; i < response.data.data.data.length; i++) {
            var time = response.data.data.data[i].create_time
            var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
            var nian = timearr[0];
            var yue = timearr[1];
            var ri = timearr[2];
            var entertime = nian + "-" + yue + "-" + ri
            ces.push({
              id: response.data.data.data[i].id,
              name: response.data.data.data[i].name,
              img: response.data.data.data[i].pic,
              entertime: entertime
            })
          }
          this.memberList = ces
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*核心专家*/
    experts() {
      let params = {}
      this.axios.post('/api/index/expertsList', params).then((response) => {
        if (response.data.msg == 'success') {
          var ces = []
          for (var i = 0; i < response.data.data.data.length; i++) {
            var time = response.data.data.data[i].create_time
            var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
            var nian = timearr[0];
            var yue = timearr[1];
            var ri = timearr[2];
            var entertime = nian + "-" + yue + "-" + ri
            ces.push({
              id: response.data.data.data[i].id,
              name: response.data.data.data[i].name,
              img: response.data.data.data[i].img,
              entertime: entertime
            })
          }
          this.expertsList = ces
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*合作机构*/
    institutions() {
      let params = {}
      this.axios.post('/api/index/institutionsList', params).then((response) => {
        console.log(response);
        if (response.data.msg == 'success') {
          var ces = []
          for (var i = 0; i < response.data.data.length; i++) {

            ces.push({
              id: response.data.data[i].id,
              name: response.data.data[i].name,
            })
          }
          this.institutionsList = ces
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*教育平台*/
    education() {
      let params = {}
      this.axios.post('/api/index/educationList', params).then((response) => {
        if (response.data.msg == 'success') {
          this.educationList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    linkTo () {
      let activeIndex = this.$refs.carousel.activeIndex
      console.log(activeIndex)
      // this.$router.push(this.imgs[activeIndex].link)
      this.$router.push({path:'Newsparticulars',query: { id: activeIndex}})
    },
    handleClick(tab) {
      if (tab.name === 'first') {
        this.news();
      } else if (tab.name === 'second') {
        this.dynamiclb()
      } else if (tab.name === 'third') {
        this.laws();
      } else if (tab.name === 'four') {
        this.notice();
      } else if (tab.name === 'five') {
        this.work();
      }
      if (tab.name == 'six') {
        if (this.qe == 'first') {
          this.$router.push({ path: '/News', query: { act: "first" } })
        } else if (this.qe == 'second') {
          this.$router.push({ path: '/News', query: { act: "second" } })
        } else if (this.qe == 'third') {
          this.$router.push({ path: '/Laws', query: { act: "first" } })
        } else if (this.qe == 'four') {
          this.$router.push({ path: '/Laws', query: { act: "second" } })
        } else if (this.qe == 'five') {
          this.$router.push({ path: '/Laws', query: { act: "third" } })
        }
      } else {
        this.qe = tab.name;
      }
    },
    con(href) {
      window.open(href)
    }
  },
  computed: {
    expertsUp() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.expertsList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    institutionsUp() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.institutionsList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    memberUp() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.memberList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
  }

}

</script>
<!--<style lang="scss" scoped>-->
<style scoped>
.whether {
  position: fixed;
  /* margin-top:5px; */
  width: 15.5%;
  z-index: 1000;
  transition: all 2s;
}

.stand {
  padding: 10px 0;
  margin: 3px 0;
}

.stand a:hover {
  color: #2F93b7;
  /* background-color: rgba(37,164,180); */
}

.stand::before {
  display: inline-block;
  content: "";
  height: 10px;
  width: 10px;
  background-color: rgba(37, 164, 180);
  margin: 0 5px;
}

.stand:nth-child(2n-1) {
  text-align: left;
  font-size: 16px;
  background-color: #B8DEF7;
}

.stand:nth-child(2n) {
  text-align: left;
  font-size: 16px;
  background-color: #D5ECFB;
}

.content {
  padding: 10px 0;
  margin: 3px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content a:hover {
  color: #2F93b7;
  /* display: block;
    width:100%;
    white-space: normal; */

}

.content::before {
  display: inline-block;
  content: "";
  height: 10px;
  width: 10px;
  background-color: rgba(37, 164, 180);
  margin: 0 5px;
}

.content2 {
  text-align: left;
  font-size: 16px;
  background-color: #D5ECFB;
}

.content1 {
  text-align: left;
  font-size: 16px;
  background-color: #B8DEF7;
}

/*滚动条样式*/
/* 滚动条的宽度 */
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(37, 164, 180);
  background: rgba(37, 164, 180);
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);

}




/*@media screen and (max-width: 500px){
  .ss{
    background-color: red;
  }
}*/

/*@media screen and (min-width: 360px){html{font-size: 48px;} }
@media screen and (min-width: 375px){html{font-size: 50px;} }
@media screen and (min-width: 384px){html{font-size: 51.2px;} }
@media screen and (min-width: 414px){html{font-size: 55.2px;} }
@media screen and (min-width: 448px){html{font-size: 59.7333px;} }
@media screen and (min-width: 480px){html{font-size: 48px;} }
@media screen and (min-width: 512px){html{font-size: 68.2667px;} }
@media screen and (min-width: 544px){html{font-size: 72.5333px;} }
@media screen and (min-width: 576px){html{font-size: 76.8px;} }
@media screen and (min-width: 608px){html{font-size: 81.0667px;} }
@media screen and (min-width: 640px){html{font-size: 85.3333px;} }
@media screen and (min-width: 750px){html{font-size: 100px;} }*/

.router-link-active {
  text-decoration: none;
}

a {
  text-decoration: none;
  color: black;
}

.jj {
  margin-bottom: 10px;
}

.jian {
  /* float: right; */
  width: 64%;
  height: 400px;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  /* padding-top: 25px; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 10;
  font-size: 14px;
  text-align: justify;
  text-indent: 2em
}

.index-roll {
  overflow: hidden;
  height: 160px;

  margin: 0 auto 10px auto;
}

.index-roll ul {
  display: flex;
  width: auto;
}

.index-roll ul li {
  margin: 0 10px;
  padding: 10px 40px;
  border-radius: 4px;
}

.index-roll ul li:hover {
  cursor: pointer;
  border-bottom: 2px solid #43aaed;
}

.index-roll ul li img {
  width: 100px;
  height: 100px;
  display: block;
}

.el-submenu {
  width: 115px;
}

li {
  list-style: none
}

.index-roll1 {
  /* overflow: hidden; */
  overflow-y: auto;
  height: 270px;
  /* margin: 0 auto 0px auto; */
  font-size: 12px;
}

.index-roll1 ul {
  width: auto;
  padding-left: 0px;

}

.index-roll1 ul li {
  padding: 3px 0px;
  border-radius: 4px;

}

.index-roll1 ul li:hover {
  cursor: pointer;
  border-bottom: 1px solid#43aaed;
}

.index-roll1 ul li img {
  width: 30%;
  height: 30%;
  display: block;

}

.index-roll2 {
  overflow: hidden;
  height: 260px;
  /* margin: 0 auto 0px auto; */
  font-size: 12px;
  /* margin: 0 auto 10px auto; */
}

.index-roll2 ul {
  width: auto;
  padding-left: 0px;
}

.index-roll2 ul li {
  padding: 3px 0px;
  border-radius: 4px;
}

.index-roll2 ul li:hover {
  cursor: pointer;
  border-bottom: 1px solid #43aaed;
}

.index-roll2 ul li img {
  width: 30%;
  height: 30%;
  display: block;
}

.index-roll2 ul li span:hover {
  display: block;
  width: 70%;
  /* overflow: auto; */
  white-space: normal;
}

.el-menu .el-menu-item {
  text-align: center;
}

.lb {
  margin-bottom: 10px;
}

.el-menu.el-menu--horizontal {
  margin-bottom: 10px;
}

.el-aside {
  float: left;
  width: 400px !important;
}

.lun_img {
  width: 400px;
  height: 250px;
  padding-top: 50px;
}

.el-tab-pane {
  margin-top: 10px;
  height: 255px;
}

.sp {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: -8px;
  margin-bottom: 20px;
}

.el-tab-pane p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: -8px;
  margin-bottom: 20px;

}

.pi {
  /* float: left; */
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  text-align: left;
  font-family: "STHeiti";
}
.pi::before {
  display: inline-block;
  content: "";
  height: 7px;
  width: 7px;
  background-color: rgb(8, 4, 4);
  margin: 0 5px;
  border-radius: 5px;


}
.pi a:hover {
  color: #2F93b7;
}
.oi {
  /* float: right; */
  font-size: 14px;
  overflow: hidden;
  /* text-overflow: ellipsis; */
  white-space: nowrap;
   width: 11%;
   margin-right: 5%;
}

/*轮翻消息*/
.bs-sysMsg {
  position: relative;
  display: flex;
  margin-bottom: 10px;
  border-radius: 2px;
  overflow: hidden;
  opacity: 1;
  align-items: center;
  transition: opacity .2s;
  height: 30px;
}

.bs-sysMsg .msg__content {
  display: table-cell;
  padding: 0 8px;
  width: 100%;
}

.bs-sysMsg .msg__content a.item {
  color: #e6a23c;
  font-size: 14px;
  opacity: 0.75;
}

.bs-sysMsg .msg__content a.item:hover {
  text-decoration: underline;
}

.bs-sysMsg .title {
  width: 134px;
  background-color: rgba(37, 164, 180);
  font-weight: bold;
  font-size: 19px;
  color: #fff;
  text-align: center;
  float: left;
  height: 30px;
  line-height: 30px;
}

.medium {
  line-height: 18px;
}

.bs-sysMsg1 {
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 2px;
  overflow: hidden;
  opacity: 1;
  align-items: center;
  transition: opacity .2s;
  border: 1px solid Gainsboro;
}

.bs-sysMsg1 .title {
  width: 134px;
  background-color: rgb(120, 120, 120, 0.5);
  font-weight: bold;
  font-size: 19px;
  color: #fff;
  text-align: center;
  float: left;
  height: 50px;
  line-height: 50px;
}

.bs-sysMsg1 .msg__content {
  display: table-cell;
  padding: 0 8px;
}

.bs-sysMsg1 .msg__content a.item {
  color: #e6a23c;
  font-size: 14px;
  opacity: 0.75;

}

.bs-sysMsg1 .msg__content a.item:hover {
  text-decoration: underline;
}

.ss {
  /* width: 1200px; */
  /* margin: 0px auto; */

}

/*@media screen and (max-width: 320px){
  .ss{
    width: 320px;
    margin: 0px auto;
  }
}*/
/*@media screen and (max-width: 320px){
  .ss{
    background-color: red;
    transform: scale(0.31) translate(-120%,0);
    -webkit-transfor: scale(0.4) translate(-120%,0);
    -moz-transform: scale(0.4) translate(-120%,0);
    -o-transform: scale(0.4) translate(-120%,0);
    -ms-transform: scale(0.4) translate(-120%,0);;
    padding-top: 0px;
  }
}*/
/*@media screen and (max-width: 320px){
  .ss{
    !*background-color: #2F93b7;*!
    transform: scale(0.31) translate(-113.5%,-162%);
  }
}*/</style>



// WEBPACK FOOTER //
// src/components/view/Index.vue